import chart from "./chart.js";
import images from "./images.js";

const ProjectDetail = {
  /**
   */
  init() {
    chart.init();
    images.init();
  },
};

export default ProjectDetail;
